import { useShopSession } from '@/services/shopSession/ShopSessionContext'

export const useShopSessionCustomer = () => {
  const { shopSession } = useShopSession()
  return shopSession?.customer ?? null
}
